export class RoleFilter {

    constructor(
        public roleIds?: number[],
        public assignable?: boolean,
        public roleTypeId?: number) {

    }
}
